// These are the standard ResMed colours

// Colours taken from http://resmedlc.com/color/
// Master ResMed Colours
export const res_pulse_blue = "#1788c3";
export const res_pulse_red = "#ed1b2f";

// Colours in the ResMed Gradient
export const res_gradient_1 = res_pulse_blue;
export const res_gradient_2 = "#008fd5";
export const res_gradient_3 = "#0083ca";
export const res_gradient_4 = "#0077c0";
export const res_gradient_5 = "#006db7";
export const res_gradient_6 = "#2062af";
export const res_gradient_7 = "#4156a6";
export const res_gradient_8 = "#55489d";
export const res_gradient_9 = "#643695";
export const res_gradient_10 = "#6f2c91";
export const res_gradient_11 = "#822a85";
export const res_gradient_12 = "#94287b";
export const res_gradient_13 = "#9d2872";
export const res_gradient_14 = "#a52868";
export const res_gradient_15 = "#ae275f";
export const res_gradient_16 = "#b72755";
export const res_gradient_17 = "#c02550";
export const res_gradient_18 = "#c9234a";
export const res_gradient_19 = "#d12244";
export const res_gradient_20 = "#da1f3d";
export const res_gradient_21 = "#e31e36";
export const res_gradient_22 = res_pulse_red;

// Secondary Colours
export const res_sc_1 = res_gradient_4;
export const res_sc_2 = res_gradient_7;
export const res_sc_3 = res_gradient_10;
export const res_sc_4 = res_gradient_13;
export const res_sc_5 = res_gradient_16;
export const res_sc_6 = res_gradient_19;

// Secondary Neutral Colours
export const res_90_black = "#424243";
export const res_snc_1 = "#d9d8d5";
export const res_snc_2 = "#b7b7b8";
export const res_snc_3 = "#9b9b9e";
export const res_snc_4 = "#e6e6e7";

// Colours taken from http://ux-resmed.ec2.local/?page_id=2230
// Meant for a messaging component
export const res_msg_primary = res_pulse_blue;
export const res_msg_primary_text = "#ffffff";
export const res_msg_secondary = res_90_black;
export const res_msg_secondary_text = "#f3f3f3";
export const res_msg_success = "#6cb454";
export const res_msg_success_text = "#ffffff";
export const res_msg_warning = "#ffc344";
export const res_msg_warning_text = "rgba(black, 0.87)";
export const res_msg_error = res_gradient_20;
export const res_msg_error_text = "#ffffff";
export const res_msg_light = "#f2f2f2";
export const res_msg_light_text = "#787878";

// Meant for a badge component
export const res_bdg_primary = "#e7f5fc";
export const res_bdg_primary_text = res_pulse_blue;
export const res_bdg_secondary = res_snc_4;
export const res_bdg_secondary_text = res_90_black;
export const res_bdg_success = "#d3e9cc";
export const res_bdg_success_text = "#026700";
export const res_bdg_warning = "#ffe9ce";
export const res_bdg_warning_text = "#db490a";
export const res_bdg_danger = "#fbcacf";
export const res_bdg_danger_text = res_gradient_18;
export const res_bdg_dark = "#212121";
export const res_bdg_dark_text = res_snc_4;
export const res_bdg_light = "#f2f2f2";
export const res_bdg_light_text = "#787878";
